// Mock-Daten für die E-Learning-Plattform

export const mockCourses = [
  {
    id: '1',
    title: 'Jahressicherheitsschulung Elektrotechnik',
    description: 'Pflichtschulung für alle Mitarbeiter im Bereich Elektrotechnik. Jährliche Auffrischung der Sicherheitsbestimmungen.',
    duration: '90 Minuten',
    price: 49.99,
    category: 'Sicherheit',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    questions: [
      {
        id: 'q1',
        question: 'Welche Spannung gilt als Hochspannung?',
        options: ['Über 230V', 'Über 400V', 'Über 1000V', 'Über 10kV'],
        correctAnswer: 2
      },
      {
        id: 'q2',
        question: 'Wie oft muss die Sicherheitsschulung wiederholt werden?',
        options: ['Alle 6 Monate', 'Jährlich', 'Alle 2 Jahre', 'Alle 5 Jahre'],
        correctAnswer: 1
      }
    ]
  },
  {
    id: '2',
    title: 'EUP - Elektrotechnisch unterwiesene Person',
    description: 'Qualifikation für Mitarbeiter, die unter Aufsicht elektrotechnische Arbeiten durchführen.',
    duration: '120 Minuten',
    price: 89.99,
    category: 'Qualifikation',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    questions: [
      {
        id: 'q1',
        question: 'Was darf eine EUP durchführen?',
        options: ['Alle elektrotechnischen Arbeiten', 'Nur unter Aufsicht arbeiten', 'Eigenständige Reparaturen', 'Hochspannungsarbeiten'],
        correctAnswer: 1
      }
    ]
  },
  {
    id: '3',
    title: 'Hochspannungstechnik Grundlagen',
    description: 'Einführung in die Hochspannungstechnik für qualifiziertes Personal.',
    duration: '180 Minuten',
    price: 149.99,
    category: 'Hochspannung',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    questions: [
      {
        id: 'q1',
        question: 'Ab welcher Spannung spricht man von Hochspannung?',
        options: ['1000V', '10kV', '30kV', '110kV'],
        correctAnswer: 0
      }
    ]
  },
  {
    id: '4',
    title: 'KFZ-Elektrotechnik & Hybridfahrzeuge',
    description: 'Sicherer Umgang mit Hochvolt-Systemen in Fahrzeugen.',
    duration: '120 Minuten',
    price: 99.99,
    category: 'KFZ',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    questions: [
      {
        id: 'q1',
        question: 'Welche Spannung haben typische Hybrid-Batterien?',
        options: ['12V', '48V', '200-400V', '1000V'],
        correctAnswer: 2
      }
    ]
  },
  {
    id: '5',
    title: 'Gebäudetechnik & Installation',
    description: 'Elektroinstallation nach DIN VDE 0100 für Gebäudetechniker.',
    duration: '150 Minuten',
    price: 119.99,
    category: 'Gebäudetechnik',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    questions: [
      {
        id: 'q1',
        question: 'Welche Norm regelt Elektroinstallationen in Deutschland?',
        options: ['DIN VDE 0100', 'DIN EN 60204', 'ISO 9001', 'VDE 0105'],
        correctAnswer: 0
      }
    ]
  },
  {
    id: '6',
    title: 'Prüfung elektrischer Anlagen',
    description: 'Durchführung von Erst- und Wiederholungsprüfungen nach DGUV V3.',
    duration: '100 Minuten',
    price: 79.99,
    category: 'Prüfung',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    questions: [
      {
        id: 'q1',
        question: 'Wie oft müssen ortsveränderliche Geräte geprüft werden?',
        options: ['Monatlich', 'Halbjährlich', 'Jährlich', 'Nach Bedarf'],
        correctAnswer: 2
      }
    ]
  }
];

export const mockCompanies = [
  {
    id: 'c1',
    name: 'ElektroTech GmbH',
    email: 'info@elektrotech.de',
    employees: [
      { id: 'e1', name: 'Max Mustermann', email: 'max@elektrotech.de', completedCourses: ['1', '2'] },
      { id: 'e2', name: 'Anna Schmidt', email: 'anna@elektrotech.de', completedCourses: ['1'] }
    ]
  }
];

export const mockCertificates = [
  {
    id: 'cert1',
    employeeId: 'e1',
    employeeName: 'Max Mustermann',
    courseId: '1',
    courseTitle: 'Jahressicherheitsschulung Elektrotechnik',
    issueDate: '2025-01-15',
    expiryDate: '2026-01-15',
    certificateNumber: 'CERT-2025-001'
  }
];

export const pricingTiers = [
  { min: 1, max: 5, discount: 0, label: '1-5 Mitarbeiter' },
  { min: 6, max: 20, discount: 10, label: '6-20 Mitarbeiter' },
  { min: 21, max: 50, discount: 15, label: '21-50 Mitarbeiter' },
  { min: 51, max: 999, discount: 25, label: 'Über 50 Mitarbeiter' }
];
